<template>
<div class="field-input-radio">
<!-- Form Input type: checkbox/switch multiple select -->
       <div class="input-group">
         <div :aria-describedby="`${fieldData.field_name}_describedby`" role="group" :aria-labelledby="`${fieldData.field_name}`" class="btn-group-toggle" data-toggle="buttons">
          <input
            :disabled="(!!showDisabled())"
            v-show="false"
            :name="fieldData.field_name"
            :id="fieldData.field_name"
            type="text"
            class="form-control"
            :maxlength="fieldData.max_length"
            v-model="fieldData.field_value"
            v-validate="field_rules">
            <template v-for="(subItem, sKey) in fieldDataOptions"  v-if="subItem.visible">
              <label :for="fieldData.field_name" :class="{
                  'disabled': !!showDisabled(),
                  'active': getMultiSwitchStatus(subItem, fieldData)
                }"
                class="btn btn-sm qrp-btn-outline float-left mb-2 mr-2"
                @click.prevent.stop="(!showDisabled() ? setMultiSwitchValue(subItem, fieldData) : '')"
                :key='sKey'>
               {{ subItem.display_value }}
               <input type="checkbox"
              class=""
              checked="" :key='(sKey+15)'>
              </label>
            </template>
          </div>
      </div>

    </div>
    <!-- Form Input type:checkbox/multiswitch -->
</template>

<script>
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  mixins: [inputFieldMixin],
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  computed: {
    fieldDataOptions() {
      if (this.fieldData && this.fieldData.field_type === 'checkbox_inline') {
        this.transformCheckboxInline();
      }

      return this.fieldData.values;
    },
  },
  methods: {
    /**
     * Transform the `checkbox_inline` into a multicheckbox object by settings is `values` to a single
     * item using its label and a stringified boolean.
     */
    transformCheckboxInline() {
      this.fieldData.values = [{
        display_order: 0,
        display_value: this.fieldData.label,
        internal_value: 'true',
        visible: true,
      }];
    },
  },
};
</script>

<style scoped>
/*
  TODO: Add IE/Edge support by implementing the `label.btn` styles via JavaScript. Bootstrap adds classes
  'focus' and 'active' to the radio <input>'s "closest" element, which happens to be the <label>.
  See https://github.com/twbs/bootstrap/blob/7c7a1706c348fcb5290a63d9249e0c8e4b6ebbcf/js/src/button.js#L153 .
*/
label.btn:focus-within {
  border-color: #001326;
  z-index: 1;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
}

.btn-outline-light {
/**NEW-TOM: Update color, border-color**/
  color: #333333;
  background-color: transparent;
  background-image: none;
  border-color: #ced4da;
}
.btn-outline-light:hover {
/**NEW-TOM: Update color, background-color, border-color**/
  color: #FFFFFF;
  background-color: #ced4da;
  border-color: #ced4da;
}

.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
/**NEW-TOM: Update color, background-color, border-color**/
  color: #FFFFFF;
  background-color: #003366;
  border-color: #003366;
}

.btn-group.btn-group-toggle .btn {
    padding: 0.1875rem 1.5rem 0;
}
label {
    display: inline-block;
    margin-bottom: 0.125rem;
    font-size: 0.75rem;
    line-height: 0.6rem !important;
    font-weight: 600;
}

label.disabled,
label.disabled:hover {
  background-color: #ffffff !important;
  color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputMulticheckbox.vue?2ccebfd8